import { CellValue } from 'react-table'

import BaseCell from './Base'

const DefaultCell = ({ value }: CellValue) => {
  return <BaseCell>{value}</BaseCell>
}

export default DefaultCell
